export class Conditions {
    public id!: string
    public filter!: string
    public order!: string[]
    public description!: string
    public name!: string
}